import { Button } from "@admin-ui/components/primitives/base/buttons/button";
import { CloseButton } from "@admin-ui/components/primitives/base/buttons/close-button";
import { FeaturedIcon } from "@admin-ui/components/primitives/foundations/featured-icon";
import type { DateValue } from "@internationalized/date";
import { Edit05 } from "@untitledui/icons";
import type { FormEvent } from "react";
import { Heading as AriaHeading } from "react-aria-components";
import { PersonFormFields } from "@/pages/admin/accounts/components/person-form-fields";

export interface EditViewProps {
  name: string;
  dateOfBirth: DateValue | null;
  onNameChange: (value: string) => void;
  onDateOfBirthChange: (value: DateValue | null) => void;
  onClose: () => void;
  onSubmit: (event: FormEvent) => void;
}

export function EditView({ name, dateOfBirth, onNameChange, onDateOfBirthChange, onClose, onSubmit }: EditViewProps) {
  return (
    <div className="pointer-events-auto relative w-full overflow-hidden rounded-2xl bg-primary shadow-xl sm:max-w-120">
      <CloseButton
        onPress={onClose}
        theme="light"
        size="sm"
        className="absolute top-3 right-3 z-10 sm:top-4 sm:right-4"
      />

      <form onSubmit={onSubmit}>
        <div className="flex flex-col gap-5 px-4 pt-5 sm:px-6 sm:pt-6">
          <div className="flex flex-col gap-4">
            <FeaturedIcon color="brand" size="md" theme="outline" icon={Edit05} />
            <div className="flex flex-col gap-1">
              <AriaHeading slot="title" className="text-lg font-semibold text-primary">
                Edit member
              </AriaHeading>
              <p className="text-sm text-tertiary">Update this member's personal details.</p>
            </div>
          </div>

          <PersonFormFields
            name={name}
            onNameChange={onNameChange}
            dateOfBirth={dateOfBirth}
            onDateOfBirthChange={onDateOfBirthChange}
          />
        </div>

        <div className="mt-5 grid grid-cols-2 gap-3 border-t border-secondary p-4 sm:px-6">
          <Button size="md" color="secondary" onClick={onClose}>
            Cancel
          </Button>
          <Button type="submit" size="md" color="primary" isDisabled={!name.trim()}>
            Save changes
          </Button>
        </div>
      </form>
    </div>
  );
}
